import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-user.details.backup-codes', {
        url: '/backup-codes',
        views: {
            '@company.user-directories.manage-user': 'companyUserDirectoriesUserBackupCodes'
        },
       
    });
}


// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/details/backup-codes/backup-codes.state.js